/*
 * Definitive Equal Height Solution for Grid Layout Overlays
 */
function setEqualOverlayHeights() {
    // Find all the grid layout wrappers on the page
    const gridLayoutWrappers = document.querySelectorAll('.grid-layout .columns-wrapper');

    // Loop through each grid section individually
    gridLayoutWrappers.forEach(function(wrapper) {
        // Find all the overlays WITHIN THIS SPECIFIC section
        const overlays = wrapper.querySelectorAll('.card-content-overlay');

        // If there are no overlays in this section, do nothing
        if (overlays.length === 0) {
            return;
        }

        let maxHeight = 0;

        // First, reset any previously set heights to allow for recalculation
        overlays.forEach(function(overlay) {
            overlay.style.height = 'auto';
        });

        // Loop 1: Find the height of the tallest overlay in this section
        overlays.forEach(function(overlay) {
            if (overlay.offsetHeight > maxHeight) {
                maxHeight = overlay.offsetHeight;
            }
        });

        // Loop 2: Apply the tallest height to all overlays in this section
        overlays.forEach(function(overlay) {
            if (maxHeight > 0) { // Only set height if we found a valid max height
                overlay.style.height = maxHeight + 'px';
            }
        });
    });
}

// Run the function on initial page load
document.addEventListener('DOMContentLoaded', setEqualOverlayHeights);

// Also run the function on window resize to handle responsive changes
window.addEventListener('resize', setEqualOverlayHeights);